// access logs
export const ACCESS_LOGS_ENDPOINT = '/organization/access-logs';
export const ACCESS_LOGS_QUERY_KEY = 'access-logs';
export const ACCESS_LOGS_UI_MARGIN_TOP = 200;
export const ACCESS_LOGS_TABLE_ID = 'access-logs-table';

// Flip to true to still render the custom-groups cluster (with a placeholder) when the org has none.
// Kept in the codebase in case we want to revert the flat-list decision.
export const EMPTY_CUSTOM_CLUSTER_ENABLED = false;
